import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import Marketing from '@services/Marketing'
import './styles.scss'
import { getParamId } from '@utilities/mdHandler'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import Loading from '@modules/core/components/Loading'
import { UserGroupsRedux } from '@modules/admin/groups/GroupsUserForm'
import { useTranslation } from 'react-i18next'
import uuid from 'uuid/v4'
import { history } from '@services/History'
import { sortArrayByKeyProp } from '@utilities/arrays'
import { FEATURE_FLAGS } from '@feature-flags/feature-flags.constants'
import { FEATURES } from '@feature-flags/features.constants'

const NewGroupsUserUpdate = (props) => {
  const id = getParamId(props)
  const [initialValues, setInitialValues] = useState({
    name: null,
    customers: [],
    teams: [],
    specialitiesSchedules: [],
    service_booking_enabled: false,
    chat_attachment_enabled: true,
  })
  const [companySpecialities, setCompanySpecialities] = useState([])
  const [allFeeds, setAllFeeds] = useState([])
  const [assignedFeeds, setAssignedFeeds] = useState([])
  const [services, setServices] = useState([])
  const [fileName, setFileName] = useState('')
  const [jsonConf, setJsonConf] = useState('')
  const [groupUUID, setGroupUUID] = useState({ uuid: '', hasGroup: false })

  const [loading, setLoading] = useState(!!id)
  const { t } = useTranslation()
  const client = Consultations.userGroups

  const submit = async (values) => {
    //todo:add parse request body if its necessary

    const requestBody = {
      ...values,
      company_id: values.company.id,
      customers_hashes: values.customers?.map((customer) => customer.hash),
      teams_ids: values.teams?.map((team) => team.id),
      specialities_ids: values?.specialities?.map((spec) => spec.id),
      has_medical_derivations: values?.services && !!values?.services?.find(({ id }) => id === 'derivations'),
      has_prescription: values?.services && !!values?.services?.find(({ id }) => id === 'prescription'),
      has_medical_reports: values?.services && !!values?.services?.find(({ id }) => id === 'reports'),
      has_video_call: values?.services && !!values?.services?.find(({ id }) => id === 'video_call'),
      has_video_call_1to1: values?.services && !!values?.services?.find(({ id }) => id === 'video_call_1to1'),
      group_options_filename: fileName,
      service_booking_enabled: Number(values.service_booking_enabled || 0),
      chat_attachment_enabled: Number(values.chat_attachment_enabled || 0),
    }

    try {
      if (id) client.update(id, requestBody)
      else client.store(requestBody)
      history.push('/groups')
    } catch (e) {
      console.error(e.message)
    }

    if (groupUUID.hasGroup) {
      try {
        const relationships = []
        FEATURE_FLAGS[FEATURES.CONTENT] &&
          assignedFeeds &&
          assignedFeeds.forEach((item) => {
            const relationshipFormated = {
              id: uuid(),
              feed_id: item.id,
              usergroup_id: values.id,
            }
            relationships.push(relationshipFormated)
          })
        Marketing.MrelationshipsGroup.delete(groupUUID.uuid).then((res) => {
          if (res.status === 204) {
            Marketing.Mrelationships.store(relationships)
          } else {
            console.error('Error haciendo el borrado de las relaciones del grupo')
          }
        })
      } catch (e) {
        console.error(e.message)
      }
    } else {
      try {
        const relationships = []
        FEATURE_FLAGS[FEATURES.CONTENT] &&
          assignedFeeds.forEach((item) => {
            const relationshipFormated = {
              id: uuid(),
              feed_id: item.id,
              usergroup_id: values.id,
            }
            relationships.push(relationshipFormated)
          })
        Marketing.Mrelationships.store(relationships)
      } catch (e) {
        console.error(e.message)
      }
    }
  }

  const fetchCompanySpecialities = async (companyId) => {
    try {
      const { data } = await Consultations.userGroups.getCompanySpecialities(companyId)
      setCompanySpecialities(data)
    } catch (e) {
      console.error(e.message)
    }
  }

  const fetchAssignedFeeds = async (groupId) => {
    try {
      const assignedFeedsArray = []
      const { data } = await Marketing.MUserGroups.index({ 'filters[eq:legacyId]': groupId })

      if (data[0]?.attributes?.feed_list?.length) {
        const { feed_list } = data[0]?.attributes
        setGroupUUID({ uuid: data[0].id, hasGroup: true })

        feed_list.forEach((item) => {
          const formatedFeed = {
            label: item.name,
            value: item.name,
            id: item.id,
          }
          assignedFeedsArray.push(formatedFeed)
        })
        setAssignedFeeds(assignedFeedsArray)
      } else {
        setGroupUUID({ uuid: data[0]?.id, hasGroup: false })
      }
    } catch (e) {
      console.error(e.message)
    }
  }

  const fetchAllFeeds = async () => {
    try {
      const feedsArray = []
      const { data } = await Marketing.MFeed.index()

      data.forEach((item) => {
        const formatedFeed = {
          label: item.attributes.name,
          value: item.attributes.name,
          id: item.attributes.id,
        }
        feedsArray.push(formatedFeed)
      })
      setAllFeeds(feedsArray)
    } catch (e) {
      console.error('Error al hacer el fetch de todos los feeds', e)
    }
  }

  const fetchServices = async (companyId) => {
    try {
      const { data } = await Consultations.company.show(companyId)
      const parsedData = data?.services.map((ser) => ({ ...ser, name: t(ser.name) }))
      setServices(parsedData)
    } catch (e) {
      console.error(e.message)
    }
  }
  const fetchData = async () => {
    setLoading(true)
    try {
      const { data } = await Consultations.userGroups.show(id)
      // const {services} = data;

      if (data.group_options_filename) setFileName(data.group_options_filename)
      if (data.group_options) setJsonConf(data.group_options)

      const teams = sortArrayByKeyProp(data.teams, 'priority')

      if (FEATURE_FLAGS[FEATURES.CONTENT]) {
        await fetchAllFeeds()
        await fetchAssignedFeeds(data.id)
      }

      await fetchCompanySpecialities(data.company.id)
      await fetchServices(data.company.id)
      setInitialValues({ ...data, teams, services: data?.services.map((ser) => ({ ...ser, name: t(ser.name) })) })
    } catch (e) {
      console.error(e.message)
    }
    setLoading(false)
  }
  useEffect(() => {
    id && fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // const titleHeader = id ? 'Editar Grupo de usuarios' : 'Crear Grupo de usuarios'
  const titleHeader = id ? t('editUserGroup') : t('newUserGroup')
  let component
  if (loading) component = <Loading isFetching={true} />
  else
    component = (
      <UserGroupsRedux
        initialValues={initialValues}
        companySpecialities={companySpecialities}
        companyServices={services}
        allFeeds={allFeeds}
        assignedFeeds={[assignedFeeds, setAssignedFeeds]}
        onSubmit={submit}
        fileName={[fileName, setFileName]}
        jsonConf={[jsonConf, setJsonConf]}
        t={t}
      />
    )

  return (
    <div className="groups-update">
      <DashboardHeader title={titleHeader} total={null}>
        <Link className="btn btn-primary" to={`/groups`}>
          {t('back')}
        </Link>
      </DashboardHeader>
      {component}
    </div>
  )
}
export default NewGroupsUserUpdate
